class EmployeeCardController {

  constructor($rootScope) {
    "ngInject";

    this.$rootScope = $rootScope;
  }

  getAvatarUrl() {
    return this.$rootScope.apiHost+"/api/users/me/avatar?" + this.$rootScope.profilePicTimeStamp;
  }

}

export default EmployeeCardController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card/employee-card.controller.js